import { render, staticRenderFns } from "./UserDropdown.vue?vue&type=template&id=1c3aad05&scoped=true"
import script from "./UserDropdown.vue?vue&type=script&lang=js"
export * from "./UserDropdown.vue?vue&type=script&lang=js"
import style0 from "./UserDropdown.vue?vue&type=style&index=0&id=1c3aad05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3aad05",
  null
  
)

export default component.exports